import React, { useState, forwardRef, useImperativeHandle } from 'react'
import './commonList.less'
import { useSelector } from 'react-redux'
import { getClientHeight } from '@/store/slices/appSlice'
import { Col, Row } from '..'
import styles from '@/style/layout.module.less'
import {
  Button,
  Dropdown,
  Input,
  List,
  Menu,
  Spin,
} from '@arco-design/web-react'
import { IconMoreVertical, IconSearch } from '@arco-design/web-react/icon'
import { useI18n } from '@/hooks/useLocale'
//通用左侧列表
export const CommonList = forwardRef(
  (
    {
      data,
      isLoading,
      keyName, //主键字段名
      filterText, //过滤字段名
      displayName, //显示字段名
      onItemChange, //选中项变化时
      rightIcon, //首行右侧按钮{name: "PlusOutlined",color: "blue",sizeClass: "medium",onClick: () => {}},
      contexMenu, //行内右侧菜单
      style,
    },
    ref
  ) => {
    const t = useI18n()
    const [activeId, setActiveId] = useState(null)
    const [keyword, setKeyword] = useState('')
    const clientHeight = useSelector(getClientHeight)
    const setCurrentItem = (item) => {
      setActiveId(item[keyName])
      onItemChange && onItemChange(item)
    }
    useImperativeHandle(ref, () => ({
      setCurrentItem, //设置当前选中项
    }))
    return (
      <>
        <div style={style}>
          {isLoading && <Spin className={styles['spin']} />}
          {data && (
            <>
              <div
                className="content-side-list-header"
                style={{ diplay: 'flex' }}
              >
                <Row>
                  <Col flex="auto">
                    <Input
                      size="small"
                      style={{ width: rightIcon ? '90%' : '100%' }}
                      placeholder={t('t_keyword')}
                      value={keyword}
                      onChange={(value, e) => setKeyword(value)}
                      allowClear={true}
                      suffix={<IconSearch />}
                    />
                  </Col>
                  <Col flex="16px">
                    {rightIcon && (
                      <div
                        style={{
                          height: '30px',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Button
                          icon={rightIcon.icon}
                          size="small"
                          shape="circle"
                          type="secondary"
                          onClick={rightIcon.onClick}
                        />
                      </div>
                    )}
                  </Col>
                </Row>
              </div>

              <div
                className="content-side-list-body"
                style={{ height: clientHeight - 248 + 'px' }}
              >
                <List
                  size="small"
                  dataSource={data
                    .filter((m) =>
                      keyword.trim() === ''
                        ? true
                        : m[filterText]
                            .toLowerCase()
                            .indexOf(keyword.trim().toLowerCase()) >= 0
                    )
                    .sort((a, b) =>
                      a[filterText].toUpperCase() > b[filterText].toUpperCase()
                        ? 1
                        : 0
                    )}
                  render={(item, index) => (
                    <List.Item
                      key={index}
                      className={item[keyName] === activeId ? 'active' : ''}
                      style={{
                        cursor: 'pointer',
                      }}
                    >
                      <div
                        onClick={() => {
                          setCurrentItem(item)
                        }}
                        className="resource-dir-header"
                      >
                        <div
                          className="resource-dir-name"
                          title={item.description}
                        >
                          {item[displayName] ?? '-'}
                        </div>
                        {contexMenu && (
                          <div className="resource-dir-menu">
                            <Dropdown
                              position="br"
                              droplist={
                                <Menu>
                                  {contexMenu?.map((m, midx) => (
                                    <Menu.Item
                                      key={'ddbot_' + midx}
                                      onClick={() => {
                                        m.onClick && m.onClick(item)
                                      }}
                                      disabled={m.disabled}
                                    >
                                      <span style={{ color: m.color }}>
                                        {m.title}
                                      </span>
                                    </Menu.Item>
                                  ))}
                                </Menu>
                              }
                            >
                              <Button
                                shape="circle"
                                type="text"
                                icon={<IconMoreVertical />}
                              />
                            </Dropdown>
                          </div>
                        )}
                      </div>
                    </List.Item>
                  )}
                />
              </div>
            </>
          )}
        </div>
      </>
    )
  }
)

